import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';
import DisciplinesBlockData from './Data';
import DisciplinesBlockView from './View';

const DisciplinesBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <DisciplinesBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <DisciplinesBlockData data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(DisciplinesBlockEdit);
